import { render, staticRenderFns } from "./popup-file-move-folder.vue?vue&type=template&id=4a6adf14&scoped=true"
import script from "./popup-file-move-folder.vue?vue&type=script&lang=js"
export * from "./popup-file-move-folder.vue?vue&type=script&lang=js"
import style0 from "./popup-file-move-folder.vue?vue&type=style&index=0&id=4a6adf14&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6adf14",
  null
  
)

export default component.exports